import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import './styles/global.css';
import { initializeAuth } from './services/auth';

// Initialize authentication from localStorage
initializeAuth();

// Add a class to prevent FOUC (Flash of Unstyled Content)
document.documentElement.classList.add('js-loading');

// Function to initialize the application with a delay to prevent flickering
const initializeApp = () => {
  const root = ReactDOM.createRoot(document.getElementById('root'));
  
  root.render(
    <BrowserRouter>
      <App />
    </BrowserRouter>
  );
  
  // Remove the js-loading class to make content visible after React has rendered
  setTimeout(() => {
    document.documentElement.classList.remove('js-loading');
  }, 100);
};

// Create a promise to ensure CSS is loaded
const cssLoaded = new Promise((resolve) => {
  // Get all CSS link elements
  const links = [...document.getElementsByTagName('link')].filter(
    link => link.rel === 'stylesheet'
  );
  
  // If no CSS links or they're all loaded, resolve immediately
  if (links.length === 0 || links.every(link => link.sheet)) {
    resolve();
    return;
  }
  
  // Count how many stylesheets have loaded
  let loadedCounter = 0;
  
  // Function to be called when each stylesheet loads
  const onLoad = () => {
    loadedCounter++;
    if (loadedCounter === links.length) {
      resolve();
    }
  };
  
  // Set up load event listeners for each stylesheet
  links.forEach(link => {
    if (link.sheet) {
      // Already loaded
      onLoad();
    } else {
      // Wait for it to load
      link.addEventListener('load', onLoad);
      link.addEventListener('error', onLoad); // Treat errors as "loaded" to avoid getting stuck
    }
  });
});

// This helps reduce flickering by ensuring that styles are loaded first
if (document.readyState === 'complete' || document.readyState === 'interactive') {
  // Document already ready, wait for CSS and then initialize
  cssLoaded.then(() => {
    setTimeout(initializeApp, 50); // Slight delay to help with smooth transition
  });
} else {
  // Document not ready, wait for it to be and then for CSS
  document.addEventListener('DOMContentLoaded', () => {
    cssLoaded.then(() => {
      setTimeout(initializeApp, 50);
    });
  });
}

// Add a comment to check the file contents
// This will help us see what's in the file